import { ErrorComponent, createRouter } from '@tanstack/react-router'
import posthog from 'posthog-js'
import { Userpilot } from 'userpilot'

import { STUDENT_APP_SCROLL_CONTAINER_ID } from '@/app/student/consts'
import { TRACK_NAVIGATION } from '@/core/constants/constants'
import keycloak from '@/core/keycloak'
import { queryClient } from '@/core/utils/react-query/queryClient'
import { track } from '@/core/utils/tracking/track'
import { trackPathnameParams } from '@/core/utils/tracking/trackPathnameParams'
import updateMixpanelLastLogin from '@/core/utils/tracking/updateMixpanelLastLogin'
import { routeTree } from '@/routeTree.gen'

import { NotFound } from './NotFound'

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface HistoryState {
    error?: string
    isListSizeChanged?: boolean
    animateOnOpen?: boolean
    previousSlug?: string
    restoreFilters?: boolean
  }
  interface Register {
    router: typeof router
  }
}

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: 'intent',
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
  defaultErrorComponent: ({ error }) => <ErrorComponent error={error} />,
  defaultNotFoundComponent: NotFound,
  scrollRestoration: true,
  scrollToTopSelectors: [`#${STUDENT_APP_SCROLL_CONTAINER_ID}`],
})

router.subscribe('onResolved', (routerEvent) => {
  if (routerEvent.hrefChanged) {
    if (posthog) {
      posthog.capture('$pageview')
    }
    if (keycloak.authenticated) {
      Userpilot.reload()
    }
    updateMixpanelLastLogin()
    track(TRACK_NAVIGATION, {
      url: window.location.toString(),
      ...trackPathnameParams({
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
      }),
    })
  }
})
